import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { forwardRef, useState } from 'react';

interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  invalid?: boolean;
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, invalid = false, ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
      <div
        className={clsx(
          'flex items-center border bg-white focus-within:border-sky-800',
          invalid ? 'border-red-600' : 'border-neutral-400',
          className,
        )}
      >
        <input
          {...props}
          ref={ref}
          type={showPassword ? 'text' : 'password'}
          aria-invalid={invalid || undefined}
          className="h-full min-w-0 flex-1 border-0!"
        />
        <button
          type="button"
          onClick={() => setShowPassword((show) => !show)}
          aria-pressed={showPassword}
          aria-label={showPassword ? 'パスワードを隠す' : 'パスワードを表示'}
          className="flex h-full shrink-0 cursor-pointer items-center gap-1 px-3 text-sm text-neutral-600 hover:text-zinc-800"
        >
          {showPassword ? <EyeSlashIcon className="size-5" /> : <EyeIcon className="size-5" />}
          {showPassword ? '隠す' : '表示'}
        </button>
      </div>
    );
  },
);

PasswordInput.displayName = 'PasswordInput';
